export default __webpack_public_path__ + "static/media/overviewBannerDesktop.cd406b81.jpg";